var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M52.2211 154.062V83.7925H75.7984L79.3356 56.3989H52.2211V38.9121C52.2211 30.9835 54.4138 25.5803 65.7963 25.5803L80.29 25.5743V1.07251C77.7835 0.746782 69.1796 0 59.1656 0C38.2547 0 23.9387 12.7638 23.9387 36.1991V56.3989H0.289978V83.7925H23.9387V154.062H52.2211Z","fill":"#010002"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 81 155","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
